import { VaultTrancheId, VAULT_TRANCHE, VAULT_TRANCHE_INFO, VAULT_TRANCHE_LABEL } from '@/app/shared/constants/vaults';

interface MarketDetailsTrancheInfoProps {
  trancheId: VaultTrancheId;
}

const MarketDetailsTrancheInfo = ({ trancheId }: MarketDetailsTrancheInfoProps) => {
  const title =
    trancheId === VAULT_TRANCHE.SENIOR ? 'Tranche information' : VAULT_TRANCHE_LABEL[trancheId];

  return (
    <div className='flex w-full flex-col gap-3 rounded-md bg-elevated-card-2 px-5 py-4'>
      <h2 className='w-full text-sm font-medium break-words text-gray-200'>{title}</h2>
      <p className='w-full text-sm leading-5 break-words text-gray-400'>{VAULT_TRANCHE_INFO[trancheId]}</p>
    </div>
  );
};

export default MarketDetailsTrancheInfo;
